import {setCacheNameDetails as workbox_core_setCacheNameDetails} from '/Users/diw-alex/Local Sites/multi/app/public/wp-content/plugins/salon-booking-plugin/build/tmp/salon-booking-system/src/SLB_PWA/pwa/node_modules/workbox-core/setCacheNameDetails.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/diw-alex/Local Sites/multi/app/public/wp-content/plugins/salon-booking-plugin/build/tmp/salon-booking-system/src/SLB_PWA/pwa/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "salon-booking-plugin-pwa"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/{SLN_PWA_DIST_PATH}/OneSignalSDKWorker.js",
    "revision": "ebb63ca15bba16b550232b0b0f66c726"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/css/app.css",
    "revision": "be62685f1e0e8b33ba09abc6b3f42e60"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/css/chunk-vendors.css",
    "revision": "86739b9274fd53e95b49abb6dab304cf"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/img/logo.png",
    "revision": "15c07bdddf699bc8c4f0ef9ee4c3effe"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/img/placeholder-image.png",
    "revision": "79c916f7860857c11c4026d8655de225"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/img/requestpayment.png",
    "revision": "d6de3842d11141326c7fed0dbb198233"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/index.html",
    "revision": "6adc6d1ca52f600968d0144745f31645"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/js/app.js",
    "revision": "62a4d15b5de3d5d1658525cf972996f7"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/js/chunk-vendors.js",
    "revision": "03e4d7579289f6a5ee56103e15fe74b5"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/manifest.json",
    "revision": "245ca91f3937002a61960214a5a2087d"
  },
  {
    "url": "/{SLN_PWA_DIST_PATH}/robots.txt",
    "revision": "b6216d61c03e6ce0c9aea6ca7808f7ca"
  }
], {});








